"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSize = exports.IconColor = void 0;
var IconColor;
(function (IconColor) {
    IconColor["Primary"] = "themePrimary";
    IconColor["Secondary"] = "themeSecondary";
    IconColor["Tertiary"] = "themeTertiary";
    IconColor["DigitalBlack"] = "digital-black";
    IconColor["White"] = "white";
    IconColor["Support20"] = "20";
    IconColor["Support40"] = "40";
    IconColor["Support60"] = "60";
    IconColor["Support80"] = "80";
    IconColor["Support100"] = "100";
    IconColor["Notification"] = "notification-strong";
    IconColor["NotificationLight"] = "notification-light";
    IconColor["Alert"] = "alert-strong";
    IconColor["AlertLight"] = "alert-light";
    IconColor["Success"] = "success";
    IconColor["SuccessLight"] = "success-light";
    IconColor["Fail"] = "fail";
    IconColor["FailLight"] = "fail-light";
    IconColor["DisableDark"] = "disable-dark-theme";
    IconColor["DisableLight"] = "disable-light-theme";
})(IconColor = exports.IconColor || (exports.IconColor = {}));
var IconSize;
(function (IconSize) {
    IconSize["ExtraSmall"] = "xs";
    IconSize["Small"] = "s";
    IconSize["MediumSmall"] = "ms";
    IconSize["Medium"] = "m";
    IconSize["Large"] = "l";
    IconSize["ExtraLarge"] = "xl";
})(IconSize = exports.IconSize || (exports.IconSize = {}));
//# sourceMappingURL=IconWrapper.types.js.map